import {
  PTI_PERMISSION_RESOLUTION_SETTINGS_APP_DETAILS,
  PTI_PERMISSION_TYPE_OPTIONAL,
  PTI_PERMISSION_TYPE_REQUIRED,
  PTI_STATUS_INACTIVE
} from '@/consts/pti/index'
import {
  checkLocationStatus,
  GEOLOCATION_DENIED,
  GEOLOCATION_GRANTED,
  getCurrentPosition, requestLocationAuthorisation
} from '@/utils/io/geolocation'
import { Platform } from 'quasar'

/**
 * Temps en seconde pour détecter si l'agent a quitté le périmètre
 * @type {number}
 */
export const PERIMETER_WATCH_INTERVAL = process.env.DEV ? 10 : 60

/**
 * Nombre de détection "Hors site" avant d'afficher une alerte PTI
 * @type {number}
 */
export const PERIMETER_RETURN_WARNING_TIME = process.env.DEV ? 3 : 5

/**
 * Temps en seconde pour retourner dans le périmètre
 * @type {number}
 */
export const PERIMETER_RETURN_TIMEOUT = process.env.DEV ? 10 : 60

export const PERIMETER_STATUS_INACTIVE = PTI_STATUS_INACTIVE
export const PERIMETER_STATUS_ACTIVE = {
  value: 'active',
  label: 'Actif'
}
export const PERIMETER_STATUS_LEAVE = {
  value: 'leave',
  label: 'Agent hors périmètre'
}
export const PERIMETER_STATUS_WARNING = {
  value: 'warning',
  label: 'Veuillez regagner le périmètre avant signalement'
}
export const PERIMETER_STATUS_SENDING = {
  value: 'sending',
  label: 'Signalement en cours'
}
export const PERIMETER_STATUS_WAIT_FOR_RETURN = {
  value: 'wait_return',
  label: 'En attente du retour dans le périmètre'
}
export const PERIMETER_STATUS_RETURN = {
  value: 'return',
  label: 'Signalement du retour dans le périmètre'
}
export const PERIMETER_STATUS_DESKTOP = {
  value: 'desktop',
  label: 'Cette fonctionnalité est indisponible sur un ordinateur'
}

export const PERIMETER_STATUS_LIST = [
  PERIMETER_STATUS_INACTIVE,
  PERIMETER_STATUS_ACTIVE,
  PERIMETER_STATUS_LEAVE,
  PERIMETER_STATUS_WARNING,
  PERIMETER_STATUS_SENDING,
  PERIMETER_STATUS_WAIT_FOR_RETURN,
  PERIMETER_STATUS_RETURN,
  PERIMETER_STATUS_DESKTOP
]

export const PTI_PERMISSION_RESOLUTION_ENABLE_GEOLOCATION = {
  key: 'enable_geolocation',
  fix: () => getCurrentPosition(),
  isAvailable: true,
  label: `Autoriser l'accès à votre localisation`
}
export const PTI_PERMISSION_RESOLUTION_ENABLE_GEOLOCATION_ALWAYS = {
  key: 'enable_geolocation_always',
  fix: () => requestLocationAuthorisation(true),
  isAvailable: true,
  label: `Autoriser l'accès à votre localisation (en arrière plan)`
}

export const PERIMETER_REQUIRED_PERMISSION_ACCESS_FINE_LOCATION = {
  key: 'ACCESS_FINE_LOCATION',
  type: PTI_PERMISSION_TYPE_REQUIRED,
  check: async () => (await checkLocationStatus()) !== GEOLOCATION_DENIED,
  isAvailable: true,
  label: 'Localisation GPS (granularité fine)',
  reason: 'Votre position GPS est requise lorsque vous êtes en service (Mains courantes, PTI...)',
  resolution: `Paramètres de l'application > Autorisations > Localisations`,
  resolutionOptions: [
    PTI_PERMISSION_RESOLUTION_ENABLE_GEOLOCATION,
    PTI_PERMISSION_RESOLUTION_SETTINGS_APP_DETAILS
  ]
}
export const PERIMETER_REQUIRED_PERMISSION_ACCESS_BACKGROUND_LOCATION = {
  key: 'ACCESS_BACKGROUND_LOCATION',
  type: PTI_PERMISSION_TYPE_OPTIONAL,
  check: async () => (await checkLocationStatus()) === GEOLOCATION_GRANTED,
  isAvailable: Platform.is.cordova,
  label: 'Localisation GPS (En tâche de fond)',
  reason: `Votre position GPS est requise lorsque vous êtes en service, y compris lorsque l'application est en tâche de fond (PTI). Sur certaines marques de téléphone, un paramètre dédié est disponible à cet effet.`,
  resolution: `Paramètres de l'application > Autorisations > Localisations > Toujours autoriser`,
  resolutionOptions: [
    PTI_PERMISSION_RESOLUTION_ENABLE_GEOLOCATION_ALWAYS,
    PTI_PERMISSION_RESOLUTION_SETTINGS_APP_DETAILS
  ]
}
export const PERIMETER_REQUIRED_PERMISSIONS = [
  PERIMETER_REQUIRED_PERMISSION_ACCESS_FINE_LOCATION,
  PERIMETER_REQUIRED_PERMISSION_ACCESS_BACKGROUND_LOCATION
]
